



































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import VoucherTemplateVue from "../components/VerifyVoucher/VoucherTemplate.vue";
import SzTypes from "../data/SzTypes";
import { Providers } from "@/data/BusinessTypes";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
        "voucher-template": VoucherTemplateVue,
    }
})
export default class VerifyJournal extends Vue {
        //分页
    currentPage: number = 1;
    pageSize: number = 20;
    totalElements: number = 0;
    totalPages: number = 0
    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
    //选中每页条数
    changeSize(size: number) {
        this.pageSize = size;
        this.fetchData();
    }
    sztypes: SzTypes[] = SzTypes.list
    shouldFetch: boolean = false //是否凭证
    isUnMatch: boolean = false
    list: Journal.Journal[] = []
    checkedInvoices: Journal.Journal[] = []
    voucherTemplate: boolean = false;
    isMulti: boolean = false;
    curTp: Journal.Journal | string = "";
    filterVisible: boolean = false;
    businessTypeList = SzTypes.list
    businessType: any = "";
    resetFilter() {
        this.businessType = ""
        this.searchKey = ""
        this.isUnMatch = false
        this.fetchData();
        this.filterVisible = false;
    }
    confirmFilter() {
        this.fetchData();
        this.filterVisible = false;
    }
    //改变时间
    period: string = ""; // 日期
    changeDate(date: string,) {
        this.period = date;
        this.checkedInvoices = [];
        this.fetchData();
    }

    isSortById = false;
    // 获取数据
    fetchData() {
        this.shouldFetch = false;
        let bus = ""
        if (this.businessType != "") {
            bus = this.businessType.id
        }
        Vue.axios
            .post(
                `journals/templates?period=${this.period}&page=${this.currentPage - 1}&size=${this.pageSize}&accountBookId=${this.$store.state.accountBook.id}&journalType=${0}&cate=3&isUnMatch=${this.isUnMatch ? 1 : 0}&searchKey=${this.searchKey}&incomePayType=${bus}&isSortById=${this.isSortById ? 1 : 0}`)
            .then(res => {
                res.data.journalList.content.forEach((v: Journal.Journal) => {
                    v.checked = false;
                })
                this.totalElements = res.data.journalList.totalElements
                this.totalPages = res.data.journalList.totalPages
                this.list = res.data.journalList.content;
                this.checkAll = this.judgeAllChecked(res.data.journalList.content);
            });
    }
    // 修改模板
    multiTemp() {
        this.curTp = "";
        this.isMulti = true;
        this.voucherTemplate = true;
    }
    closeTp() {
        this.fetchData();
        this.isMulti = false;
    }
    // 选择模板
    chooseTp(index: number) {
        this.curTp = this.list[index];
        this.voucherTemplate = true;
    }
    // 多选
    checkAll: boolean = false
    selectAll(val: boolean) {
        for (let i = 0; i < this.list.length; i++) {
            this.$set(this.list[i], "checked", val);
        }
    }
    // 监听列表数据
    @Watch("list", { deep: true })
    checkedChange(val: Journal.Journal[]) {
        let all = val.length > 0 ? true : false;
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                this.removeElement(val[i]);
            } else {
                if (!this.judgeInclude(val[i])) this.checkedInvoices.push(val[i]);
            }
        }
        this.checkAll = all;

    }
    judgeInclude(v: Journal.Journal) {
        for (let i = 0; i < this.checkedInvoices.length; i++) {
            if (this.checkedInvoices[i].id === v.id) return true;
        }
        return false
    }
    judgeAllChecked(content: Journal.Journal[]) {
        let all = content.length > 0 ? true : false;;
        for (let i = 0; i < content.length; i++) {
            let bool = this.judgeInclude(content[i]);
            content[i].checked = bool;
            if (!bool) all = false;
        }
        return all;
    }
    removeElement(v: Journal.Journal) {
        for (let i = 0; i < this.checkedInvoices.length; i++) {
            if (this.checkedInvoices[i].id === v.id) this.checkedInvoices.splice(i, 1);
            break;
        }
    }
    // 获取 金额数值
    getAmount(item: Journal.Journal) {
        if (item.pay === "") return item.income;
        else return item.pay
    }
    // 使用模板
    useTp(tp: Journal.Journal) {
        if (!this.isMulti) {
            let curTp = <Journal.Journal>this.curTp
            curTp.voucherTemplateId = tp.id;
            Vue.axios
                .put(
                    `journals`, this.curTp)
                .then(res => {
                    this.voucherTemplate = false;
                    this.fetchData();
                });
        } else {
            Vue.axios
                .put(
                    `journals/multi`, {
                    journalList: this.checkedInvoices,
                    voucherTemplateId: tp.id
                })
                .then(res => {
                    this.voucherTemplate = false;
                    this.checkedInvoices = [];
                    this.fetchData();
                });
        }
        this.isMulti = false;
    }
    // 搜索凭证号
    searchKey: string = ""
    startSearch() {
        this.fetchData()
    }
    // 搜索关键字
    hlInner(con: string) {
        if (this.searchKey != "") {
            let reg = new RegExp(`${this.searchKey}`, "gim");
            return con.replace(
                reg,
                `<span class="hl">${this.searchKey}</span>`
            );
        } else {
            return con;
        }
    }
}
